// .u_home-slider

(function ($) {
  var $slider = $('.u_home-slider')
  $slider.each(function (i, thisSlider) {
    homeSliderInit($(thisSlider))
  })

  function homeSliderInit (thisSlider) {
    $(thisSlider).slick({
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000
    })
  }
})(window.jQuery)
